import styled from 'styled-components';

export const Container = styled.span`
  .react-tool-tip {
    max-width: 500px;
  }
`;
